<template>
  <div class="AgstOpel">
    <div class="AgstOpel-background">
      <div class="AgstOpel-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        兑欧宝
        <!-- <p><router-link :to="{path: 'ExchCord'}">兑换记录</router-link></p> -->
      </div>
      <router-link :to="{path: 'CardBag',query: {HoCardBag: '3',secaus: '1'}}">
        <div class="AgstOpel-CardTion">
          <div class="AgstOpel-CardTion-left"></div>
          <div class="AgstOpel-CardTion-center">
            <p class="AgstOpel-CardTion-center-text">兑欧宝卡号</p>
            <p>{{this.agsebr}}</p>
          </div>
          <div class="AgstOpel-CardTion-right"></div>
        </div>
      </router-link>
      <div class="AgstOpel-OpelNumber">
        <p class="AgstOpel-OpelNumber-text">兑欧宝</p>
        <div class="AgstOpel-OpelNumber-Recharge">
          <span>￥</span>
          <el-input type="Number" pattern="[0-9]*" v-model="AgRearge" placeholder="请输入兑欧宝数" @input="AgRechge()"></el-input>
        </div>
      </div>
      <div class="AgstOpel-rule" @click="agstonpt()">兑欧宝规则说明</div>
      <button class="AgstOpel-confirm" @click="agexnw()">立即兑欧宝</button>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + agstfail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{agsttips}}</p>
      </div>
    </div>
    <!-- 成功提示 -->
    <div id="toast" :style="'display:' + agstsucs">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-success-no-circle weui-icon_toast"></i>
        <p class="weui-toast__content">{{agsttips}}</p>
      </div>
    </div>
    <!-- 选择框 -->
    <div id="dialogs">
      <div class="js_dialog" id="iosDialog1" style="display: none;">
        <div class="weui-mask" @click="agstmask()"></div>
        <div id="js_dialog_1" class="weui-half-screen-dialog">
          <div class="weui-half-screen-dialog__hd">
            <div class="weui-half-screen-dialog__hd__side">
              <button class="weui-icon-btn" @click="agstmask()">关闭<i class="weui-icon-close-thin"></i></button>
            </div>
            <div class="weui-half-screen-dialog__hd__main">
              <strong class="weui-half-screen-dialog__title">请输入支付密码</strong>
            </div>
          </div>
          <div class="weui-half-screen-dialog__bd">
            <div class="CardDetails-paword">
              <el-input type="password" v-model="agstpsod" placeholder="请输入密码" clearable show-password @input="agstpard()"></el-input>
              <button @click="agstoptn()">确认</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 提示语 -->
    <div class="js_dialog" id="iosDialog2" :style="'display:' + agsthint">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__bd">兑欧宝说明</div>
        <div class="AgstOpel-proent">
          1、您所操作的兑欧宝申请，将即时在您账户余额中扣除。当日即按新余额计算积分。<br>
          2、您当日15时前的兑欧宝申请，将于下个工作日向您预留的银行账户转账；当日15时后的兑欧宝申请于下下个工作日向您预留的银行账户转账。<br>
          3、您可在App上实时查询兑欧宝处理状态。<br>
          等待受理：表示系统已收到您的兑欧宝申请；<br>
          已受理：表示系统已审核同意您的兑欧宝申请；<br>
          受理完毕：表示系统已完成向您预留的银行账户转账；<br>
          未通过：表示您的兑欧宝申请未被系统通过。
        </div>
        <div class="weui-dialog__ft">
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" @click="agstclpt()" style="color: #f10100">知道了</a>
        </div>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      AgRearge: '',
      loginID: '',
      agsebr: '',
      agstfail: 'none',
      agsttips: '',
      agstsucs: 'none',
      agstpsod: '',
      agsthint: 'none'
    }
  },
  created () {
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    // 接收兑换记录(卡包)传过来的卡号
    this.agsebr = this.$route.query.exsebr;
  },
  mounted () {

  },
  methods: {
    // 打开提示语
    agstonpt(){
      this.agsthint = 'block'
    },
    // 关闭提示语
    agstclpt(){
      this.agsthint = 'none'
    },
    // 获取要充值的欧宝数
    AgRechge(){
      // console.log(this.AgRearge);
    },
    // 点击立即兑欧宝向后台提交相关信息
    agexnw(){
      if(this.AgRearge == ''){
        this.agsttips = '金额不能为空';
        this.agstfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.agstfail = 'none';
        },1200)
      }else{
        this.$('#js_dialog_1').addClass('weui-half-screen-dialog_show');
        this.$('#iosDialog1').fadeIn(200);
      }
    },
    // 获取用户输入的密码
    agstpard(){
      // console.log(this.agstpsod);
    },
    // 点击遮罩层或者关闭按钮时输入支付密码弹框消失
    agstmask(){
      this.$('#js_dialog_1').removeClass('weui-half-screen-dialog_show');
      this.$('#iosDialog1').fadeOut(200);
      this.agstpsod = ''
    },
    // 点击确认提交提现需要的数据
    agstoptn(){
      if(this.agstpsod == ''){
        this.agsttips = '支付密码不能为空';
        this.agstfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.agstfail = 'none';
        },1200)
      }else{
        this.$axios.post('wx/withdrawApply',this.$qs.stringify({
          token: this.loginID,
          amount: this.AgRearge,
          cnumber: this.agsebr,
          cpassword: this.agstpsod
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          if(res.data.code == '200'){
            this.agsttips = res.data.msg;
            this.agstsucs = 'block';
            const _this = this;
            setTimeout(function(){
              _this.agstsucs = 'none';
              _this.AgRearge = '';
              _this.$router.push({name: 'ExchCord',query: {sechbr: _this.agsebr}});
            },1200)
          }else{
            this.agsttips = res.data.msg;
            this.agstfail = 'block';
            const _this = this;
            setTimeout(function(){
              _this.agstfail = 'none';
            },1200)
          }
        })
        .catch(() => {
          console.log('获取失败');
        });
      }
      this.$('#js_dialog_1').removeClass('weui-half-screen-dialog_show');
      this.$('#iosDialog1').fadeOut(200);
      this.agstpsod = '';
    },
    // 返回上一层
    BackLevel(){
      this.$router.push({name: 'ExchCord',query: {sechbr: this.agsebr}});
    }
  }
}
</script>

<style scoped>
  @import "obraocs/AgstOpel.css";
</style>